<div class="lm-simple-progress" [attr.title]="title">
  <div *ngIf="width > 0" class="{{colorClass}}" [style.width.%]="width"></div>
  <div class="lm-range-text {{inverseClass}}">{{displayValue}}</div>
</div>